export enum StarCleanerVisitStatus {
    PENDING = 'PENDING',
    ALLOCATED = 'ALLOCATED',
    CANCELLED = 'CANCELLED',
    FULFILLED = 'FULFILLED',
    RESCHEDULED = 'RESCHEDULED',
}